export default [
  { mount_element: 'overview-app', loader: () => import('./overview/Overview.vue') },
  { mount_element: 'inventory-sortfilter-menu', loader: () => import('./inventory/InventorySortFilter.vue') },
  { mount_element: 'active-inventory-app', loader: () => import('./inventory/ActiveInventory.vue') },
  { mount_element: 'archived-inventory-app', loader: () => import('./inventory/ArchivedInventory.vue') },
  { mount_element: 'inventory-gallery-app', loader: () => import('./inventory-gallery/InventoryGallery.vue') },
  { mount_element: 'active-leads-app', loader: () => import('./leads/ActiveLeads.vue') },
  { mount_element: 'archived-leads-app', loader: () => import('./leads/ArchivedLeads.vue') },
  { mount_element: 'active-vendors-app', loader: () => import('./vendors/ActiveVendors.vue') },
  { mount_element: 'archived-vendors-app', loader: () => import('./vendors/ArchivedVendors.vue') },
  { mount_element: 'leads-inventory-graph-app', loader: () => import('./overview/LeadsInventoryGraph.vue') },
  { mount_element: 'active-deal-app', loader: () => import('./deals/ActiveDeal.vue') },
  { mount_element: 'archived-deal-app', loader: () => import('./deals/ArchivedDeal.vue') },
  { mount_element: 'form-folders-app', loader: () => import('./form/FormFolders.vue') },
  { mount_element: 'bhph-deal-app', loader: () => import('./deals/BhphDeal.vue') },
  { mount_element: 'close-deal-app', loader: () => import('./deals/BhphClosedDeal.vue') }
]
